import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { Commission } from 'types/embedded/commission';

import { GatewayRulesFormValues } from '../../hooks/useGatewayRulesForm';

type Params = {
  mappingIndex: number;
  mappingItemIndex: number;
  commissions?: Partial<Commission>[];
};

export function useAutoSelectCommissions({ mappingIndex, mappingItemIndex, commissions }: Params) {
  const { watch, setValue, getValues } = useFormContext<GatewayRulesFormValues>();

  const gatewayWatched = watch(`mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.gateway`);
  const merchantAccountWatched = watch(
    `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.merchantAccount`,
  );

  const canAutoSelectCommissions = Boolean(gatewayWatched) && Boolean(merchantAccountWatched);

  useEffect(() => {
    if (!canAutoSelectCommissions || !commissions?.length) {
      return;
    }

    const current = getValues(
      `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.commissions`,
    );
    if (current?.length) {
      return;
    }

    const allTypes = commissions.flatMap((c) => c.transactionTypes ?? []);
    const hasNoDuplicates = allTypes.length === new Set(allTypes).size;

    if (!hasNoDuplicates) {
      return;
    }

    setValue(
      `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.commissions`,
      commissions.map((c) => c.id),
      { shouldDirty: true, shouldValidate: true },
    );
  }, [commissions, canAutoSelectCommissions]);
}
